import { render } from "./PantrySearchDialog.vue?vue&type=template&id=61fb1901&ts=true"
import script from "./PantrySearchDialog.vue?vue&type=script&lang=ts"
export * from "./PantrySearchDialog.vue?vue&type=script&lang=ts"

import "./PantrySearchDialog.vue?vue&type=style&index=0&id=61fb1901&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__